import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';
import * as i0 from "@angular/core";
export class SymbolSwitcherModule {
}
SymbolSwitcherModule.ɵfac = function SymbolSwitcherModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SymbolSwitcherModule)(); };
SymbolSwitcherModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SymbolSwitcherModule });
SymbolSwitcherModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseAutocompleteModule] });
